import React from "react";
import { Button, ProgressBar } from "react-bootstrap";
import ModalContainer from "../ModalContainer";
import styles from "./styles/editModal.module.scss";
import { FaXmark } from "react-icons/fa6";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
} from "chart.js";
import "chart.js/auto";
import { CardTitle, ImageWithPlaceholder } from "../CustomComponents";
import profile from '../../assets/images/dispatcher_profile.png'
import { formatDateTime, formatTime } from "../../Helper";
import { useGetOfficerLogsQuery, useMarkOfficerMutation } from "../../Data/services/officerApi";
import { SuccessToast } from "../../Hooks/useToast";
import moment from "moment";
import MapFixed from "../Map/MapFixed";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setOffersSlug } from "../../Data/features/officerSlice";
import { X } from "@mui/icons-material";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement);

export default function VitalsModal({ handleClose, data }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [markOfficer] = useMarkOfficerMutation();
  const oneHourFromNow = moment().add(1, 'hour').format();
  const { data: officerdata, error } = useGetOfficerLogsQuery(
    {
      id: data.id ? data.id : '',
      start_datetime: oneHourFromNow,
      end_datetime: moment().format(),
    },
    { refetchOnMountOrArgChange: true }
  );
  const officerlog = officerdata?.data?.filter(x => x.id === data.id);

  function beatColor(beatCount) {
    if (beatCount >= 95 && beatCount <= 240) {
      return "#FF0000";
    } else if (beatCount >= 85 && beatCount < 95) {
      return "#FE740B";
    } else if (beatCount >= 40 && beatCount < 85) {
      return "#23AD23";
    }
    return "#000";
  }

  const officerUpdate = async () => {
    try {
      const result = await markOfficer(data.id);
      console.log(result);

      if (result?.data?.code === 200) {
        SuccessToast("Notification Status Updated");
        handleClose();
      }
    } catch (e) {
      console.error("Error:", e.response ? e.response.data : e.message);
    }
  };

  return (
    <ModalContainer handleClose={handleClose}>
      <div
        className={`max-w-lg-75 d-flex align-items-center justify-content-between mb-4 ${styles.vitalsModal}`}
      >
        <div className={styles.vitalleft}>
          <div className="w-100 d-flex justify-content-center">
            <div className={styles.header}>
              <ImageWithPlaceholder
                src={data.image_url ? data.image_url : "/images/user-placeholder.jpeg"}
                alt="Officer"
                className={styles.profileImage}
                placeholder={"/images/user-placeholder.jpeg"}
              />
              <div className={styles.userInfo}>
                <h5 className="text-capitalize">{data.name}</h5>
              </div>
            </div>
            <p className={`${styles.xmark} bg-opacity-75 d-flex p-3 rounded-5`}>
              <FaXmark
                role="button"
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              />
            </p>
          </div>
          <div className={styles.content}>
            <div className={styles.infoSection}>
              <div className={styles.infoRow}>
                <p>
                  <strong>Badge:</strong>
                </p>
                <p className="text-black">{data?.badge_no}</p>
              </div>
              <div className={styles.infoRow}>
                <p>
                  <strong>Last Report:</strong>
                </p>
                <p className="text-black">{formatDateTime(data?.createdAt)}</p>
              </div>
              <div className={styles.infoRow}>
                <p>
                  <strong>HR:</strong>
                </p>
                <p>
                    <span className={beatColor(data?.heart_rate) === "#FF0000" ? styles.highLighted : beatColor(data?.heart_rate) === "#FE740B" ? styles.waiting : styles.connected }>
                      {data.heart_rate} bpm
                    </span>
                  </p>
              </div>
              <div className={styles.infoRow}>
                <p>
                  <strong>Temperature:</strong>
                </p>
                <p className="text-black">{officerlog?.data?.temperature} F</p>
              </div>
              <div className={styles.infoRow}>
                <p>
                  <strong>Motion:</strong>
                </p>
                <p className="text-black">{officerlog?.data?.motion}</p>
              </div>
              <div className={styles.infoRow}>
                <p>
                  <strong>Perspiration:</strong>
                </p>
                <p className="text-black">{officerlog?.data?.prespiration}</p>
              </div>
              {data?.send_help === 1 && (
                  <div className={styles.infoRow}>
                    <p>
                      <strong>Status:</strong>
                    </p>
                    <p className="text-black">
                      <span className={styles.waiting}>
                        Waiting for Officer Response
                      </span>
                    </p>
                  </div>
                )}
                <div className={styles.infoRow}>
                  <p>
                    <strong>Connection Status:</strong>
                  </p>
                  {data.status && (
                    <p className="text-black">
                      <span className={styles.connected}>Connected</span>
                    </p>
                  )}
                </div>
            </div>
          </div>
          <div className={styles.footer}>
            <button className={`${styles.officerOk} fs-9`} onClick={officerUpdate}>
              <p>Officer is OK</p>
            </button>
            <button className={`${styles.assistNow} fs-9`} onClick={() => {navigate('/chat'); dispatch(setOffersSlug(data))}}>
              <p>Assist Now</p>
            </button>
          </div>
        </div>
        <div className={styles.vitalsGraph}>
          <div className={styles.graphDiv}>
            <CardTitle text='Vitals' classes="text-black fs-5 fw-bold" />
            <p className="m-0 fs-6">Heart rate: 185</p>
            <VitalsGraph record={officerlog?.data?.officer_log} />
          </div>

          <div className="w-100" style={{ height: "230px", border: 0, borderRadius: '10px' }}>
          <MapFixed location={{ lat: data?.latitude ? data?.latitude : 24.9324, lng:  data?.longitude ? data?.longitude : 67.0873 }} />
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}

export const VitalsGraph = ({record}) => {
  const data = {
    labels: [formatTime(record?.datetime)],
    datasets: [
      {
        label: "Heart Rate",
        data: [record?.heart_rate], // heart rate values
        borderColor: "red",
        fill: false,
        tension: 0.4, // to create smooth curves
      },
    ],
  };

  const options = {
    scales: {
      y: {
        min: 50,
        max: 200,
      },
    },
  };

  return <Line data={data} options={options} />;
};
